(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers')
        .controller('VisualGuidelinesComponentConfirmClickController', Controller);

    Controller.$inject = ['$scope', '$alert'];

    function Controller($scope, $alert) {

        $scope.confirmCtxt = {};

        $scope.confirmClick = function () {
            $alert({
                title: 'Confirmed action!',
                content: 'This action is confirmed.',
                placement: 'top-right',
                type: 'success',
                duration: 5,
                show: true
            });
        }
    }
})();